<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        <span
          v-if="value"
          class="d-inline-block text-truncate"
        >
          {{ pageType == 'in' ? $t("Requisition.batchPricing") : $t("Requisition.outBatchPricing") }}
        </span>
        <span
          class="red--text d-inline-block text-truncate"
        >
            {{
              $t("Material.materialNameWithCode", [
                currentItem.material_code,
                currentItem.material_name
              ])
            }}
        </span>
        <span class="red--text d-inline-block text-truncate">[
          <span v-if="currentItem.standard_name && currentItem.standard_name.length > 12" :title="currentItem.standard_name" style="cursor: pointer">
            {{ currentItem.standard_name.slice(0, 12) + "......" }}
          </span>
          <span v-else>
            {{ currentItem.standard_name }}
          </span>]
        </span>
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
              >fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("$vuetify.close") }}
          </span>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-container v-if="value">
          <v-data-table
            :headers="requisitionHeaders"
            :items="requisitionIns"
            dense
            multi-sort
            disable-pagination
            hide-default-footer
            fixed-header
          >
            <template v-slot:header.price="{ header }">
              <v-text-field
                v-model="batchPrice"
                single-line
                dense
                hide-details
                type="number"
                style="max-width: 150px; font-weight:normal"
                :placeholder="$t('Requisition.batchPricingPlaceholder')"
              >
                <template v-slot:prepend>
                  <span class="caption" style="min-width: 30px">{{ header.text }}</span>
                </template>
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="batchPricing()"
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-check
                  </v-icon>
                </template>
              </v-text-field>
            </template>
            <template v-slot:item.total_num="{ item }">
              {{ item.total_num | formatTwoDot }}
            </template>
            <template v-slot:item.price="{ item }">
              <v-text-field
                v-model="item.price"
                single-line
                dense
                hide-details
                type="number"
                style="max-width: 150px"
                @blur="item.price = $numberFormatter.formatMoney(item.price)"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="pricing(item)"
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-check
                  </v-icon>
                </template>
              </v-text-field>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="primary"
          @click="batchPricing('batchSave')"
        >
          {{$t("CRUD.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Requisitions from "@/api/requisitions";

export default {
  name: "RequisitionListsDialog",

  props: {
    value: Boolean,
    searcherData: Object,
    currentItem: Object,
    pageType: String,
  },

  computed: {
    requisitionHeaders() {
      return [
        {
          text: this.pageType == 'in' ? i18n.t("Requisition.Fields.stock_in_order_code") : i18n.t("Requisition.Fields.stock_out_order_code"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: this.pageType == 'in' ? i18n.t("Requisition.Fields.stock_requisition_in") : i18n.t("Requisition.Fields.stock_requisition_out"),
          align: "start",
          sortable: false,
          value: "stock_name",
        },
        {
          text: i18n.t("Requisition.DetailFields.total_num"),
          align: "start",
          sortable: false,
          value: "total_num",
        },
        {
          text:i18n.t("Requisition.DetailFields.price"),
          align: "start",
          sortable: false,
          width: 200,
          value: "price"
        }
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    requisitionIns: [],
    batchPrice: "",
  }),

  methods: {
    getPricingOrders() {
      this.$store.dispatch("fullscreenLoading");
      Requisitions.getPricingOrders(Object.assign({}, this.searcherData, {
        material_ids: [this.currentItem.material_id]
      }), this.pageType).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.requisitionIns = response.data.requisition_ins.map((detail) => {
              detail.price = this.$numberFormatter.formatMoney(detail.price);
              return detail
            })
            this.$store.dispatch("fullscreenLoadingStop");
          }else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      )
    },
    pricing(data) {
      if (data.price == ''){
        this.$snackbar.error(i18n.t("Requisition.Messages.noPrice"));
        return
      }
      this.$store.dispatch("fullscreenLoading");
      let postData = {
        id: data.detail_id,
        price: data.price
      }
      Requisitions.orderPricing(postData, this.pageType).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getPricingOrders()
            this.$snackbar.success(i18n.t("Requisition.Messages.pricingSuccess"));
            this.$store.dispatch("fullscreenLoadingStop");
          }else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      )
    },
    async batchPricing(type = 'pricing') {
      if (this.batchPrice == '' && type == 'pricing'){
        this.$snackbar.error(i18n.t("Requisition.Messages.noPrice"));
        return
      }
      this.$store.dispatch("fullscreenLoading");
      let successCount = 0;
      let errorCount = 0;

      for (let i = 0; i < this.requisitionIns.length; i++) {
        if (type == 'pricing') {
          let postData = {
            id: this.requisitionIns[i].detail_id,
            price: this.batchPrice
          }
          let response = await Requisitions.orderPricing(postData, this.pageType)
          if (response.data.status.isOK()) {
            successCount ++;
          }else {
            errorCount ++;
          }
        }else if (type == 'batchSave') {
          if (this.requisitionIns[i].price) {
            let postData = {
              id: this.requisitionIns[i].detail_id,
              price: this.requisitionIns[i].price
            }
            let response = await Requisitions.orderPricing(postData, this.pageType)
            if (response.data.status.isOK()) {
              successCount ++;
            }else {
              errorCount ++;
            }
          }else {
            errorCount ++;
          }
        }
      }
      this.$snackbar.info(i18n.t("Requisition.Messages.batchInfo", [successCount, errorCount]));
      this.$store.dispatch("fullscreenLoadingStop");
      this.getPricingOrders()
    }
  },

  watch: {
    dialog: {
      handler() {
        if (!this.dialog) this.$emit("input", null);
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
          this.getPricingOrders()
        }else {
          this.requisitionIns = [];
          this.batchPrice = ""
        }
      },
    },
  },
};
</script>